export const DRIVER_ID = 'DRIVER_ID';
export const DRIVER_EVENT_ID = 'DRIVER_EVENT_ID';
export const DRIVER_LOAD_ID_2 = 'DRIVER_LOAD_ID_2';
